/** Return the base domain (sub.domain.co.uk → domain.co.uk). */
export const getBaseDomain = (url: string): string => {
    try {
        const { hostname } = new URL(url);
        const parts = hostname.split('.');
        return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
    } catch {
        return url;
    }
};
